const customGoogleTranslate = (lang: any) => {
	const translateActivated =
		document.getElementById('google_translate_element') || null;
	if (translateActivated) {
		//@ts-ignore
		const txt = js_trad.TranslateIn;
		const googleSelect = document.querySelector(
			'.goog-te-combo'
		) as HTMLSelectElement;
		translateActivated.insertAdjacentHTML(
			'beforeend',
			`<ul class="custom-translate"></ul>`
		);
		const customTranslate =
			translateActivated.querySelector('.custom-translate');
		customTranslate.insertAdjacentHTML(
			'beforeend',
			`<li class="custom-translate__item current-lang notranslate" data-code="fr">FR</li>`
		);

		for (let i = 0; i < lang.length; i++) {
			let flag: any;
			lang[i][0] === 'en' ? (flag = 'gb') : (flag = lang[i][0]);
			customTranslate.insertAdjacentHTML(
				'beforeend',
				`<li class="custom-translate__item" 
            data-code="${lang[i][0]}">
            <span class="fi fi-${flag}"></span>
            <span class="sr-only">${txt} ${lang[i][1]}</span>
            </li>`
			);
		}
		const items = customTranslate.querySelectorAll(
			'.custom-translate__item'
		);
		const current = customTranslate.querySelector(
			'.current-lang'
		) as HTMLElement;
		items.forEach((item) => {
			item.addEventListener('click', () => {
				const getCode = item.getAttribute('data-code');
				Array.from(googleSelect.options).forEach((opt) => {
					if (opt.value === getCode) {
						googleSelect.value = getCode;
						current.innerHTML = getCode;
						googleSelect.dispatchEvent(new Event('change'));
						waitForElm('.goog-te-banner-frame').then(
							(root: any) => {
								if (root) {
									const iWindow = root.contentWindow;
									const iDocument = iWindow.document;
                                    const w = window.innerWidth;
                                    const close = iDocument.querySelector('.goog-close-link');
                                    if(w < 550){
                                        //@ts-ignore
                                        const closeTxt = js_trad.CloseTranslate
                                        const closeBtnExists = document.querySelector('.close-modale-translate') || null;
                                        if(closeBtnExists){
                                            closeBtnExists.remove();
                                        }
                                        iDocument.querySelector('.goog-te-banner').style.overflowX = 'auto';
                                        document.querySelector('.header').insertAdjacentHTML('afterend',`<div class="close-modale-translate notranslate">
                                       <button role="button">
                                       <span class="sr-only">${closeTxt}</span>
                                      X
                                       </button>
                                        </div>`);
                                        const closeBtn = document.querySelector('.close-modale-translate') || null;
                                        closeBtn.querySelector('button').addEventListener('click',(e) =>{
                                            e.preventDefault();
                                            const blocTranslate = document.querySelector('.skiptranslate') as HTMLElement;
                                            blocTranslate.style.display="none";
                                            closeBtn.remove();
                                        })
                                    }
									const buttons =
										iDocument.querySelectorAll(
											'.goog-te-button'
										);
                                     
                                        close.addEventListener('click',() => {
                                            current.innerHTML = 'FR'
                                        })
									for (let i = 0; i < buttons.length; i++) {
										const btn = buttons[i].querySelector('button');
										btn.addEventListener('click', () => {
                                            const blocTranslate = document.querySelector('.skiptranslate') as HTMLElement;
                                            blocTranslate.style.display="block";
											btn.innerHTML ===
											"Afficher l'original"
												? (current.innerHTML = 'FR')
												: (current.innerHTML = getCode);
										});
									}
								}
							}
						);
					}
				});
			});
		});
	}
};
